export const MODULES = [
  {
    id: 'foundation',
    number: 'M01',
    title: 'Foundation',
    subtitle: 'Three-Phase Basics',
    description: 'AC phasors, balanced three-phase systems, voltage relationships, and power fundamentals.',
    route: '/foundation',
    status: 'live',
    prerequisites: [],
    color: 'teal',
    icon: 'Zap',
  },
  {
    id: 'transformers',
    number: 'M02',
    title: 'Transformer Systems',
    subtitle: 'Delta-Wye, Vector Groups',
    description: 'Delta-wye connections, vector group notation, transformer impedance, and autotransformers.',
    route: '/transformers',
    status: 'live',
    prerequisites: ['foundation'],
    color: 'purple',
    icon: 'ArrowLeftRight',
  },
  {
    id: 'per-unit',
    number: 'M03',
    title: 'Per-Unit Analysis',
    subtitle: 'System Normalization',
    description: 'Normalize multi-voltage networks to a common base. The language of power systems fault analysis.',
    route: '/per-unit',
    status: 'live',
    prerequisites: ['foundation', 'transformers'],
    color: 'teal',
    icon: 'Sliders',
  },
  {
    id: 'symmetrical-components',
    number: 'M04',
    title: 'Symmetrical Components',
    subtitle: 'Positive/Negative/Zero Sequence',
    description: "Fortescue's theorem: decompose any unbalanced fault into three balanced sequence sets.",
    route: '/symmetrical-components',
    status: 'live',
    prerequisites: ['per-unit'],
    color: 'teal',
    icon: 'GitBranch',
  },
  {
    id: 'sequence-networks',
    number: 'M05',
    title: 'Sequence Networks',
    subtitle: 'Building Sequence Models',
    description: 'Build positive, negative, and zero-sequence Thevenin network models for any power system.',
    route: '/sequence-networks',
    status: 'live',
    prerequisites: ['symmetrical-components'],
    color: 'teal',
    icon: 'Network',
  },
  {
    id: 'fault-analysis',
    number: 'M06',
    title: 'Fault Analysis',
    subtitle: 'SLG, LL, DLG, Three-Phase',
    description: 'Calculate fault currents, fault MVA, and equipment duty for all standard fault types.',
    route: '/fault-analysis',
    status: 'coming-soon',
    prerequisites: ['sequence-networks'],
    color: 'slate',
    icon: 'AlertTriangle',
  },
  {
    id: 'protection',
    number: 'M07',
    title: 'Protection & Grounding',
    subtitle: 'Coordination, TCC Curves',
    description: 'System grounding methods, overcurrent relay coordination, time-current curves, and CTI.',
    route: '/protection',
    status: 'coming-soon',
    prerequisites: ['fault-analysis'],
    color: 'slate',
    icon: 'Shield',
  },
  {
    id: 'distribution-design',
    number: 'M08',
    title: 'Distribution Design',
    subtitle: 'Feeder Design, SAIDI/SAIFI',
    description: 'Feeder topology, voltage drop, conductor selection, capacitor placement, and reliability metrics.',
    route: '/distribution-design',
    status: 'coming-soon',
    prerequisites: ['foundation', 'transformers', 'protection'],
    color: 'slate',
    icon: 'GitMerge',
  },
];

export const getModuleById = (id) => MODULES.find(m => m.id === id);
export const getLiveModules = () => MODULES.filter(m => m.status === 'live');
